import { combineReducers } from 'redux';
import { jobsReducer } from './jobsReducer';
import { dealersReducer } from './dealersReducer';
import { printReducer } from './printReducer'
import { reportsReducer } from './reportsReducer';
import { employeesReducer } from './employeesReducer';
import {dataReducer} from './dataReducer'


export default combineReducers({
  jobs: jobsReducer,
  dealers: dealersReducer,
  reports: reportsReducer,
  employees: employeesReducer,
  print:printReducer,
  data:dataReducer

});
